import designer from '@/api/view/designer.js'

import successful_case from '@/api/view/successful_case.js'
import join from '@/api/view/join.js'//入驻平台
import exhibition from '@/api/view/exhibition.js'//毕业展
import school_design from '@/api/view/school_design.js'
import exp from '@/api/view/exp.js';//经历

export default {
    ...designer,
    ...successful_case,
    ...join,
    ...school_design,
    ...exp,
    ...exhibition
}
